import { useDestinationTable } from 'modules/dataSync/contexts';
import { useDataSyncTranslations } from 'modules/dataSync/hooks/useDataSyncTranslations';
import { PAGE_SIZES_MEDIUM, PaginationUpdateEvent } from 'ui/paginationFooter';
import { StyledPaginationFooter } from './DestinationPagination.styles';

export const DestinationPagination = () => {
  const { t } = useDataSyncTranslations();
  const { currentPage, pageSize, totalItems, setPage, setPageSize } = useDestinationTable();

  const handlePaginationUpdate = ({ page, pageSize: newPageSize }: PaginationUpdateEvent) => {
    // Only update page if it actually changed
    if (page !== currentPage) {
      setPage(page);
    }

    // Only update pageSize if it actually changed
    if (newPageSize !== pageSize) {
      setPageSize(newPageSize);
    }
  };

  // Only show pagination if there are items to paginate
  if (totalItems === 0) {
    return null;
  }

  return (
    <StyledPaginationFooter
      onUpdate={handlePaginationUpdate}
      pageSizes={PAGE_SIZES_MEDIUM}
      currentPage={currentPage}
      itemsPerPage={pageSize}
      numItems={totalItems}
      content={{ total: t('table.destination.pagination.total') }}
    />
  );
};
